import React, { useState } from 'react';
import ConfirmButton from '../../../components/buttons/confirmButton';
import TextInput, { inputType } from '../../../components/inputs/textInput';

const TipsCustomInput = ({ onConfirm }) => {
  const [amount, setAmount] = useState(0);

  return (
    <div>
      <TextInput
        id="custom-amount"
        placeholder="0.00"
        onChange={setAmount}
        value={amount}
        type={inputType.price}
      />
      <ConfirmButton
        onClick={() => {
          const parsedAmount = parseFloat(amount);
          onConfirm(Number.isNaN(parsedAmount) ? 0 : parsedAmount);
        }}
      />
    </div>
  );
};

export default TipsCustomInput;
